// import React, { useEffect, useState } from "react";
// import "./FocusPage.css";
// import axios from "axios";
// function FocusPage() {

//   const [Summary, setSummary] = useState([]);
//   const [Services, setServices] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_service1"
//       );
//       setSummary(response.data.data);
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/service2_list"
//       );
//       setServices(response.data.data);
//     };

//     fetchData();
//   }, []);

//   return (
//     <div className="top-focus mb-5">
//       {Summary.map((data, index) => {
//   return (
//     <div className="container focus-table" key={index}>
//       <h1><strong>{data.ser1_title}</strong></h1>
//     <p>
//      {data.ser1_description}
//    </p>
//     </div>
//     );
// })}   
//       {Services.map((Data, index) => (
//   <div
//     className={`container technology-sec ${index % 2 === 0 ? "zig-left" : "zig-right"}`}
//     key={index}
//   >
//     <h1 className="technology-heading">
//       <strong>{Data.ser2_head}</strong>
//     </h1>
//     <div className="row technology-data for-effect">
//       {/* Conditional rendering for zig-zag */}
//       {index % 2 === 0 ? (
//         <>
//           <div className="technology-img col-lg-6 col-md-12 col-sm-12">
//             <img
//               src={`https://cyberathon.com/NLF/${Data.ser2_image}`}
//               alt="technology"
//             />
//           </div>
//           <div className="technology-content-sec col-lg-6 col-md-12 col-sm-12">
//             <p
//               className="technology-para"
//               dangerouslySetInnerHTML={{ __html: Data.ser2_paragraph }}
//             ></p>
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="technology-content-sec col-lg-6 col-md-12 col-sm-12">
//             <p
//               className="technology-para"
//               dangerouslySetInnerHTML={{ __html: Data.ser2_paragraph }}
//             ></p>
//           </div>
//           <div className="technology-img col-lg-6 col-md-12 col-sm-12">
//             <img
//               src={`https://cyberathon.com/NLF/${Data.ser2_image}`}
//               alt="technology"
//             />
//           </div>
//         </>
//       )}
//     </div>
//   </div>
// ))}

//     </div>
//   );
// }

// export default FocusPage;

import React, { useEffect, useState } from "react";
import "./FocusPage.css";
import axios from "axios";
import PageLoader from "../PageLoader";

function FocusPage() {

  const [Summary, setSummary] = useState([]);
  const [Services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      
      const [res1, res2] = await Promise.all([
        axios.get("https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_service1"),
        axios.get("https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/service2_list")
      ]);

      setSummary(res1.data.data);
      setServices(res2.data.data);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) return <PageLoader />;

  return (
    <div className="top-focus mb-5">
      {Summary.map((data, index) => {
        return (
          <div className="container focus-table" key={index}>
            <h1><strong>{data.ser1_title}</strong></h1>
            <p>{data.ser1_description}</p>
          </div>
        );
      })}

      {Services.map((Data, index) => (
        <div
          className={`container technology-sec ${index % 2 === 0 ? "zig-left" : "zig-right"}`}
          key={index}
        >
          <h1 className="technology-heading">
            <strong>{Data.ser2_head}</strong>
          </h1>
          <div className="row technology-data for-effect">
            {index % 2 === 0 ? (
              <>
                <div className="technology-img col-lg-6 col-md-12 col-sm-12">
                  <img
                    src={`https://cyberathon.com/NLF/${Data.ser2_image}`}
                    alt="technology"
                  />
                </div>
                <div className="technology-content-sec col-lg-6 col-md-12 col-sm-12">
                  <p
                    className="technology-para"
                    dangerouslySetInnerHTML={{ __html: Data.ser2_paragraph }}
                  ></p>
                </div>
              </>
            ) : (
              <>
                <div className="technology-content-sec col-lg-6 col-md-12 col-sm-12">
                  <p
                    className="technology-para"
                    dangerouslySetInnerHTML={{ __html: Data.ser2_paragraph }}
                  ></p>
                </div>
                <div className="technology-img col-lg-6 col-md-12 col-sm-12">
                  <img
                    src={`https://cyberathon.com/NLF/${Data.ser2_image}`}
                    alt="technology"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FocusPage;